import { Button } from '@/components/ui/button'
import { DateRangePicker } from '@/components/ui/DateRangePicker'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select'
import { type FilterOptions, Granularity } from '@/models/agentRunReport'

const ANY = '__any__'

const GRANULARITIES = [
  { value: Granularity.DAY, label: 'Day' },
  { value: Granularity.WEEK, label: 'Week' },
  { value: Granularity.MONTH, label: 'Month' },
]

export interface AgentRunFilterState {
  start: string
  end: string
  granularity: Granularity
  agent: string
  model: string
  vendor: string
}

export function AgentRunFilters({
  state,
  options,
  onChange,
  onDateRange,
}: {
  state: AgentRunFilterState
  options?: FilterOptions
  onChange: (key: keyof AgentRunFilterState, value: string) => void
  onDateRange: (start: string, end: string) => void
}) {
  return (
    <div className="flex flex-col gap-3 sm:flex-row sm:flex-wrap sm:items-center">
      <DateRangePicker start={state.start} end={state.end} onChange={onDateRange} />
      <div className="flex gap-2">
        {GRANULARITIES.map((g) => (
          <Button
            key={g.value}
            variant={state.granularity === g.value ? 'default' : 'outline'}
            onClick={() => onChange('granularity', g.value)}
          >
            {g.label}
          </Button>
        ))}
      </div>
      <FilterSelect
        label="All agents"
        value={state.agent}
        values={options?.agentSlugs ?? []}
        onChange={(value) => onChange('agent', value)}
        className="w-full sm:w-56"
      />
      <FilterSelect
        label="All models"
        value={state.model}
        values={options?.models ?? []}
        onChange={(value) => onChange('model', value)}
        className="w-full sm:w-52"
      />
      <FilterSelect
        label="All vendors"
        value={state.vendor}
        values={options?.vendors ?? []}
        onChange={(value) => onChange('vendor', value)}
        className="w-full sm:w-36"
      />
    </div>
  )
}

function FilterSelect({
  label,
  value,
  values,
  onChange,
  className,
  labelFor,
}: {
  label: string
  value: string
  values: string[]
  onChange: (value: string) => void
  className?: string
  labelFor?: (value: string) => string
}) {
  return (
    <Select value={value || ANY} onValueChange={(next) => onChange(next === ANY ? '' : next)}>
      <SelectTrigger className={className}>
        <SelectValue placeholder={label} />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value={ANY}>{label}</SelectItem>
        {values.map((option) => (
          <SelectItem key={option} value={option}>
            {labelFor ? labelFor(option) : option}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}
